import { createStyles } from '@material-ui/core';
var MuiAutocompleteOverride = createStyles({
  inputRoot: {
    '&&[class*="MuiOutlinedInput-root"] $input': {
      padding: 0
    }
  }
});
export default MuiAutocompleteOverride;